import React from "react";
import get from "lodash/get";
import "../radio-page-helsinki/radio-page.m.css";
import { useDispatch, useSelector } from "react-redux";
import { RADIOT_HELSINKI } from "../../../store/actions";

const RadioPageHelsinki = () => {
  const dispatch = useDispatch();
  return (
    <div styleName="radio-container">
      <div styleName="radio-wrapper">
        <div>
          <h2>Dei pääkaupunkiseutu</h2>
          <p>Enemmä toivoo stadii!</p>
        </div>
        <div styleName="mhz">
          <i className="ri-radio-fill"></i>
          <h2>PK-seutu / 89.0 MHz</h2>
        </div>
      </div>
      <div styleName="container">
        <div styleName="radio-img">
          <img src="https://fiare-stg-thumbor.assettype.com/dei/2025-03-27/8oeiax8g/paakaupunkiseutu.png" />
        </div>
        <div styleName="overlay">
          <h2>Radio Dei pääkaupunkiseutu</h2>
          <p>Uskoa, toivoa ja yhteyttä joka kujalle ja kadulle. </p>

          <div styleName="kuuntele-radio">
            <i className="ri-radio-fill ri-3x"></i>
            <button
              onClick={() => {
                dispatch({
                  type: RADIOT_HELSINKI,
                  isRadiotHelsinkiClicked: true,
                });
              }}
            >
              Kuuntele
            </button>
          </div>
        </div>
      </div>
      <div styleName="kanavan-wrapper">
        <div styleName="kanavan-esittely">
          <h2>Radio Dei pääkaupunkiseutu</h2>
          <p>
            Valtakunnallisen lähetyksen lisäksi Radio Dei lähettää pääkaupunkiseudulla myös alueellista ohjelmaa
            maanantai-iltaisin klo 18-20 välillä sekä Suomen Raamattuopiston jumalanpalveluksen sunnuntaisin klo 11-12.
            Pääkaupunkiseudun taajuus on Radio Dein ensimmäinen taajuus ja aloitti toimintansa Helsingissä vuonna 1997.
          </p>
          <h2>Kuuluvuusalue</h2>
          <p>
            Helsingin taajuus kuuluu pääkaupunkiseudun lisäksi lähes koko Uudenmaan alueella. Tarkemmat kuuluvuusalueet
            näkyvät kuuluvuusaluekartasta.
          </p>
        </div>
        {/* <div styleName="kanavan-tiedot">
          <h2>Kanavan Tiedot</h2>
          <div styleName="kanavan-tiedot-info">
            <p styleName="first-para">Taajuus: </p>
            <p> 89.0 MHz / 101.9 MHz</p>
          </div>
          <div styleName="kanavan-tiedot-info">
            <p styleName="first-para">Taajuus: </p>
            <p> 89.0 MHz / 101.9 MHz</p>
          </div>
          <div styleName="kanavan-tiedot-info">
            <p styleName="first-para">Taajuus: </p>
            <p> 89.0 MHz / 101.9 MHz</p>
          </div>
        </div>*/}
      </div>
      <div styleName="radio-wrapper-lower">
        <div styleName="radio-lower-info">
          <h2>Kuuluvuusaluekartta</h2>
          <p>
            Keltainen väri kuvastaa virallista kuuluvuusaluetta. Punainen alue on lähes yhtä hyvä. Sinisellä alueella
            Dei kuuluu hyvin autossa, paikasta ja radiosta riippuen myös muulla tavoin.
          </p>
        </div>
        <div styleName="location-img">
          <img src="https://s3-alpha-sig.figma.com/img/9fb7/a7cb/822718f6c64c40d29ce2158f00a56edc?Expires=1744588800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=T-BadTz2YXpRgop1crGr-XJKxEL~20DYarl0etBh5lRfRI9ndCFR47i19fY~Wi9rq6OF6scCsrz7whA5lZfO7LXin5jsR4wHMmMuAnfr59uBM6lTrrapScZ810kAkG71v4z6O-t1djcCc593Zii~DT-4WDUmifTfaiCiuLLSV1Bx~Rns0tNo1rL0p3WKWIVtiJmn8QCozmzctvTXTADjY9Zz7DFH1pMf2VUmpeDAdKwCQLXjFQl3FJThnKSBNaZLJuoucPGYcHO64NB8dRWedYN36HYluEhPzR4Te0e198ysgS9VYD-iknc~q313pY9ThQy4lJqka387A8-yf8XcFw__" />
        </div>
      </div>
    </div>
  );
};

export { RadioPageHelsinki };
